import { Grid } from "@mui/material";
import { IPropsGrid } from "../../types/components";

export const BFGridOneLine = ({ children, props = {} }: IPropsGrid) => {

    return (
        <Grid item lg={12} md={12} sm={12} xl={12} xs={12}
            {...props}>
            {children}
        </Grid>
    )
}

export const BFGridContainer = ({ children, props = {} }: IPropsGrid) => {
    return (
        <Grid container
            {...props}>
            {children}
        </Grid>
    )
}